import { render } from "./selecProduDetails.vue?vue&type=template&id=0f2cf957&scoped=true"
import script from "./selecProduDetails.vue?vue&type=script&lang=js"
export * from "./selecProduDetails.vue?vue&type=script&lang=js"

import "./selecProduDetails.vue?vue&type=style&index=0&id=0f2cf957&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2cf957"]])

export default __exports__